"use strict";
'use client';

/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Experimental__IconMicOff = Experimental__IconMicOff;
exports.IconMicOff = IconMicOff;
var _react = _interopRequireDefault(require("react"));
var _index = require("../../index.js");
/**
 * Our icon component is built on top of Encore's icon set.
 * Read our [iconography documentation](https://encore.spotify.net/foundations/iconography?format=figma-figma) to learn more about the principles our icons were designed upon.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-icon--docs) |
 * [Encore site](https://encore.spotify.net/web/components/icon) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Icon/icons/IconMicOff/index.tsx)
 */
function IconMicOff(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M8 0a4 4 0 0 0-4 4v3c0 .898.296 1.727.795 2.394L3.55 10.64A5.724 5.724 0 0 1 2.25 7V6H.75v1c0 1.796.653 3.44 1.734 4.705L.47 13.72a.75.75 0 0 0 1.05 1.071L14.953 1.356l.011-.01.065-.066A.75.75 0 0 0 13.97.22l-2.267 2.266A4.001 4.001 0 0 0 8 0zm4 6.432L10.142 8.29c-.21.348-.504.642-.852.852l-1.823 1.823A4 4 0 0 0 12 7v-.568zm-5.972 5.971-1.144 1.145c.73.348 1.527.577 2.366.664V16h1.5v-1.788A7.251 7.251 0 0 0 15.25 7V6h-1.5v1a5.75 5.75 0 0 1-7.722 5.403zm-.154-4.087A2.487 2.487 0 0 1 5.5 7V4a2.5 2.5 0 0 1 4.983-.294l-4.61 4.61z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M12 0a5 5 0 0 0-5 5v6c0 .91.244 1.766.67 2.502l-2.167 2.167A7.96 7.96 0 0 1 4 11V8a1 1 0 0 0-2 0v3a9.96 9.96 0 0 0 2.074 6.098l-2.281 2.28a1 1 0 0 0 1.357 1.468L20.477 3.518l.064-.06 1.666-1.665A1 1 0 0 0 20.793.379L16.94 4.23A5.001 5.001 0 0 0 12 0zm5 10.531-5.449 5.45A5 5 0 0 0 17 11v-.47zm-7.92 7.92-1.514 1.514a9.937 9.937 0 0 0 3.434.986V24h2v-3.05c5.053-.501 9-4.765 9-9.95V8a1 1 0 1 0-2 0v3a8 8 0 0 1-10.92 7.45zM9.17 12A3.004 3.004 0 0 1 9 11V5a3 3 0 1 1 6 0v1.172L9.17 12z\'/>'
  }];
  var iconSizeValue = props.size ? _index.IconSizeMap[props.size] : props.iconSize;
  var closestSize = (0, _index.findClosestGlyphAvailable)(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/_react["default"].createElement(_index.Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconMicOff is deprecated and will be archived soon. Use IconMicOff instead.
 */
function Experimental__IconMicOff(props) {
  return /*#__PURE__*/_react["default"].createElement(IconMicOff, props);
}